module.exports = __webpack_public_path__ + "img/Rectangle.bfdb8780.png";